import Competencies from './Competencies.vue';

export default Competencies;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/competencies/index.ts